import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'

import {INDICATOR_SIZE, MAX_SCORE} from './settings.js'

export const Indicator = ({progress, maxScore = MAX_SCORE, trailing, size = INDICATOR_SIZE.MEDIUM}) => {
  const {i18n} = useContext(Context)
  return (
    <div className="mt-RatingFeatureIndicator" data-testid="indicator">
      <p className="mt-RatingFeatureIndicator-text">
        <span className={`mt-RatingFeatureIndicator-progress mt-RatingFeatureIndicator-progress--${size}`}>
          {progress}
        </span>
        <VisuallyHidden>{i18n.t('COMMON.OUT_OF_MAX_SCORE', {maxScore})}</VisuallyHidden>
        {!!trailing && (
          <span aria-hidden className="mt-RatingFeatureIndicator-trailing">
            {trailing}
          </span>
        )}
      </p>
    </div>
  )
}

Indicator.displayName = 'RatingFeature.Indicator'
Indicator.propTypes = {
  progress: PropTypes.number.isRequired,
  size: PropTypes.string,
  maxScore: PropTypes.number,
  trailing: PropTypes.string
}
